module.exports = __webpack_public_path__ + "static/media/banner-image-lg.fefc2c76.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/images/banner-image-lg.jpeg
// module id = 1599
// module chunks = 1